// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"ColumnImage_tableHeader__itxpy","tableBody":"ColumnImage_tableBody__eGSXS"};